<template>
  <FormContainer @submitForm="saveCosto">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del costo"
        v-model="costo.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Ricavo collegato"
        v-model="costo.ricavoId"
        :options="ricaviWithAll"
        optionLabel="name"
        optionValue="id"
        :errorMsg="errorHash['ricavoId']"
        @input="selectRicavo"
      />
    </div>
    <div class="row">
      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        v-model.number="costo.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Quota proporzionale"
        v-model.number="costo.quota"
        :errorMsg="errorHash['quota']"
        @input="removeError('quota')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Ritenuta fiscale"
        v-model.number="costo.ritenuta"
        :errorMsg="errorHash['ritenuta']"
        @input="removeError('ritenuta')"
      />

      <FormInputSelectDilazioneWidget
        class="col-lg-4 col-sm-6"
        label="Giorni di dilazione"
        v-model.number="costo.dilazione"
        :errorMsg="errorHash['dilazione']"
        @input="removeError('dilazione')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Mese del primo costo"
        v-model="costo.begin"
        :errorMsg="errorHash['begin']"
        @input="removeError('begin')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Ultimo mese del costo"
        not-required
        v-model="costo.end"
        :errorMsg="errorHash['end']"
        @input="removeError('end')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva costo
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputSelectDilazioneWidget: () => import('./Widgets/FormInputSelectDilazioneWidget'),
  },
  props: {
    costo: {
      type: Object,
      default: () => ({
        name: null,
        dilazione: 0,
        vat: 22,
        quota: 0,
        ritenuta: 0,
        ricavoId: null,
        begin: null,
        end: null,
      }),
    },
    ricavi: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ricaviWithAll () {
      return [{ id: null, name: 'Tutti i ricavi' }, ...this.ricavi];
    },
    ricavoSelected () {
      const ricavo = (this.ricavi || []).find(r => r.id === this.costo.ricavoId);
      if (!ricavo) {
        return null;
      }

      return ricavo;
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.costo.name) {
        this.addError('Il nome del costo è obbligatorio', 'name');
      }

      if (!this.costo.vat && this.costo.vat !== 0) {
        this.addError('Il campo iva è obbligatorio', 'vat');
      }

      if (!this.costo.quota && this.costo.quota !== 0) {
        this.addError('La quota del ricavo è obbligatoria', 'quota');
      }

      if (!this.costo.ritenuta && this.costo.ritenuta !== 0) {
        this.addError('La ritenuta fiscale è obbligatoria', 'ritenuta');
      }

      if (!this.costo.begin) {
        this.addError('Il mese del primo costo è obbligatorio', 'begin');
      }

      if (this.costo.end && this.costo.end < this.costo.begin) {
        this.addError('Il mese dell\'ultimo mese deve essere successivo al primo', 'end');
      }

      if (this.ricavoSelected && this.ricavoSelected.begin && this.costo.begin < this.ricavoSelected.begin) {
        this.addError('Il mese del primo costo deve essere uguale o successivo al primo ricavo (' + this.ricavoSelected.begin + ')', 'begin');
      }

      return !this.hasErrors;
    },
    selectRicavo () {
      this.removeError('ricavoId');

      if (this.costo.begin) {
        return;
      }

      if (!this.ricavoSelected) {
        return;
      }

      if (!this.ricavoSelected.begin) {
        return;
      }

      this.costo.begin = this.ricavoSelected.begin;
      this.removeError('begin');
    },
    saveCosto () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.costo);
    },
  },
};

</script>
